var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m164.446 58.564h323.727c12.827 0 23.327 10.5 23.327 23.356v192.462c0 12.827-10.5 23.327-23.327 23.327h-323.727c-12.827 0-23.327-10.5-23.327-23.327v-192.462c0-12.856 10.5-23.356 23.327-23.356z",
    fill: "#60b7ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m70.644 16.971h144.703v267.649h-144.703z",
    fill: "#6c9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m192.659 67.785v165.208c-13.205 0-23.938 11.634-23.938 26.003h-51.482c0-14.368-10.704-26.003-23.909-26.003v-165.208c13.205 0 23.909-11.634 23.909-26.003h51.482c.001 14.368 10.733 26.003 23.938 26.003z",
    fill: "#396",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.124 201.813c-7.999 23.036-3.083 50.726 18.004 84.233l63.931-57.736c-31.18-24.374-58.201-32.082-81.935-26.497z",
    fill: "#ffc2df",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m281.866 201.813c7.97 23.036 3.054 50.726-18.033 84.233l-63.931-57.736c31.18-24.374 58.23-32.082 81.964-26.497z",
    fill: "#ffc2df",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m70.644 216.792c22.454-10.587 47.294-15.968 72.337-15.968s49.912 5.381 72.366 15.968v67.828h-144.703z",
    fill: "#396",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m93.331 208.095c16.026-4.828 32.78-7.272 49.65-7.272s33.652 2.443 49.679 7.272v24.897c-13.205 0-23.938 11.634-23.938 26.003h-51.482c0-14.368-10.704-26.003-23.909-26.003z",
    fill: "#1c7a4b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m215.87 217.054c13.176 6.253 25.508 14.31 36.561 24.112 8.493 7.533 15.997 15.939 22.367 25.014-2.996 6.37-6.632 13.001-10.965 19.866l-63.931-57.736c5.439-4.246 10.762-7.998 15.968-11.256z",
    fill: "#ff5ca8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.192 266.18c6.37-9.075 13.874-17.481 22.367-25.014 11.053-9.802 23.385-17.859 36.561-24.112 5.177 3.258 10.5 7.01 15.939 11.256l-63.931 57.736c-4.304-6.865-7.94-13.467-10.936-19.866z",
    fill: "#ff5ca8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m142.981 214.174c78.561 0 142.26 56.514 142.26 126.233 0 32.431-13.787 62.011-36.445 84.349-7.184 7.097-10.151 16.492-8.319 26.41l4.857 26.381c.814 4.479-.291 8.667-3.199 12.158-2.909 3.49-6.835 5.323-11.373 5.323h-38.277c-5.294 0-9.715-3.839-10.471-9.075l-3.316-23.327c-11.402 2.618-23.385 4.014-35.718 4.014s-24.287-1.396-35.689-4.014l-3.345 23.327c-.727 5.235-5.148 9.075-10.471 9.075h-38.247c-4.566 0-8.464-1.832-11.373-5.323-2.938-3.491-4.014-7.679-3.199-12.158l4.828-26.381c1.832-9.918-1.105-19.313-8.319-26.41-22.628-22.337-36.415-51.918-36.415-84.348 0-69.72 63.669-126.234 142.231-126.234z",
    fill: "#ffc2df",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m142.981 389.65c21.32 0 38.713-17.393 38.713-38.713 0-21.291-17.393-38.685-38.713-38.685-21.291 0-38.684 17.393-38.684 38.685-.001 21.32 17.393 38.713 38.684 38.713z",
    fill: "#ff5ca8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m142.981 445.117c-22.694 0-41.157-15.383-41.157-34.292 0-3.968 3.217-7.184 7.184-7.184 3.968 0 7.184 3.217 7.184 7.184 0 10.986 12.017 19.924 26.789 19.924s26.788-8.938 26.788-19.924c0-3.968 3.217-7.184 7.184-7.184s7.184 3.217 7.184 7.184c0 18.908-18.463 34.292-41.156 34.292z",
    fill: "#ff5ca8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m106.303 296.284c9.773 0 17.742-7.97 17.742-17.772 0-9.773-7.97-17.742-17.742-17.742-9.802 0-17.772 7.969-17.772 17.742.001 9.803 7.97 17.772 17.772 17.772z",
    fill: "#ff5ca8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m179.687 296.284c9.773 0 17.742-7.97 17.742-17.772 0-9.773-7.97-17.742-17.742-17.742-9.773 0-17.742 7.969-17.742 17.742 0 9.803 7.969 17.772 17.742 17.772z",
    fill: "#ff5ca8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m458.244 171.577v-22.914c6.317 1.831 10.849 5.958 10.849 10.627 0 3.968 3.217 7.184 7.184 7.184 3.968 0 7.184-3.217 7.184-7.184 0-12.356-10.798-22.72-25.217-25.351v-10.135c0-3.968-3.217-7.184-7.184-7.184-3.968 0-7.184 3.217-7.184 7.184v10.135c-14.419 2.631-25.218 12.994-25.218 25.351 0 12.607 10.619 22.847 25.218 25.408v22.941c-6.318-1.836-10.85-5.973-10.85-10.653 0-3.968-3.217-7.184-7.184-7.184-3.968 0-7.184 3.217-7.184 7.184 0 12.607 10.619 22.847 25.218 25.408v10.106c0 3.968 3.217 7.184 7.184 7.184 3.968 0 7.184-3.217 7.184-7.184v-10.106c14.598-2.561 25.217-12.801 25.217-25.408s-10.619-22.849-25.217-25.409zm-25.218-12.288c0-4.669 4.532-8.796 10.85-10.627v21.28c-6.318-1.836-10.85-5.972-10.85-10.653zm25.218 48.349v-21.307c6.317 1.836 10.849 5.973 10.849 10.653 0 4.681-4.532 8.818-10.849 10.654z",
    fill: "#ffd039"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e9eef2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.711 106.527h79.463c3.968 0 7.184-3.217 7.184-7.184 0-3.968-3.217-7.184-7.184-7.184h-79.463c-3.968 0-7.184 3.217-7.184 7.184s3.216 7.184 7.184 7.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.174 123.688h-79.463c-3.968 0-7.184 3.217-7.184 7.184s3.217 7.184 7.184 7.184h79.463c3.968 0 7.184-3.217 7.184-7.184s-3.216-7.184-7.184-7.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.174 155.188h-79.463c-3.968 0-7.184 3.217-7.184 7.184 0 3.968 3.217 7.184 7.184 7.184h79.463c3.968 0 7.184-3.217 7.184-7.184s-3.216-7.184-7.184-7.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.174 186.717h-79.463c-3.968 0-7.184 3.217-7.184 7.184s3.217 7.184 7.184 7.184h79.463c3.968 0 7.184-3.217 7.184-7.184s-3.216-7.184-7.184-7.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.174 218.246h-79.463c-3.968 0-7.184 3.217-7.184 7.184s3.217 7.184 7.184 7.184h79.463c3.968 0 7.184-3.217 7.184-7.184s-3.216-7.184-7.184-7.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.174 249.746h-79.463c-3.968 0-7.184 3.217-7.184 7.184 0 3.968 3.217 7.184 7.184 7.184h79.463c3.968 0 7.184-3.217 7.184-7.184s-3.216-7.184-7.184-7.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m294.286 411.29h160.642c9.802 0 17.859 8.028 17.859 17.83v48.079c0 9.802-8.057 17.83-17.859 17.83h-160.642c-9.802 0-17.83-8.028-17.83-17.83v-48.079c0-9.802 8.028-17.83 17.83-17.83z",
    fill: "#f99608",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m332.999 327.551h160.642c9.831 0 17.859 8.028 17.859 17.83v48.05c0 9.831-8.028 17.859-17.859 17.859h-160.642c-9.802 0-17.83-8.028-17.83-17.859v-48.05c.001-9.802 8.028-17.83 17.83-17.83z",
    fill: "#ffd039",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m451.699 327.551h41.942c9.831 0 17.859 8.028 17.859 17.83v48.05c0 9.831-8.028 17.859-17.859 17.859h-41.942c9.802 0 17.83-8.028 17.83-17.859v-48.05c0-9.802-8.028-17.83-17.83-17.83z",
    fill: "#f99608",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m412.957 411.29h41.971c9.802 0 17.859 8.028 17.859 17.83v48.079c0 9.802-8.057 17.83-17.859 17.83h-41.971c9.831 0 17.859-8.028 17.859-17.83v-48.079c-.001-9.802-8.028-17.83-17.859-17.83z",
    fill: "#e07f00",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m142.981 214.174c78.561 0 142.26 56.514 142.26 126.233 0 32.431-13.787 62.011-36.445 84.349-7.184 7.097-10.151 16.492-8.319 26.41l4.857 26.381c.814 4.479-.291 8.667-3.199 12.158-2.909 3.49-6.835 5.323-11.373 5.323h-12.332c4.537 0 8.464-1.832 11.373-5.323s4.014-7.679 3.17-12.158l-4.828-26.381c-1.832-9.918 1.134-19.313 8.319-26.41 22.658-22.338 36.416-51.918 36.416-84.349 0-67.887-60.353-123.237-136.064-126.117 2.063-.058 4.099-.116 6.165-.116zm-36.038 250.722-2.996 21.058c-.727 5.235-5.148 9.075-10.471 9.075h-12.332c5.294 0 9.715-3.839 10.471-9.075l3.316-23.327c3.955.901 7.969 1.658 12.012 2.269z",
    fill: "#ff5ca8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m472.408 58.564h15.765c12.827 0 23.327 10.5 23.327 23.356v192.462c0 12.827-10.5 23.327-23.327 23.327h-15.765c12.827 0 23.327-10.5 23.327-23.327v-192.462c0-12.856-10.5-23.356-23.327-23.356z",
    fill: "#3e97e0",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.f684718388863685de8792ad5983eb36.svg";
export { ForwardRef as ReactComponent };